// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1IlTR","icon":"SortAdornment_icon__6_ELq","up":"SortAdornment_up__1mcfG","down":"SortAdornment_down__7fDZO","active":"SortAdornment_active__sFArB"};